import "./index.css";
import "./App.scss";
import "bootstrap/dist/css/bootstrap.min.css";
import WebAppView from "./webapp/WebAppView.jsx";

function App() {
  return (
    <div className="App">
      <WebAppView />
    </div>
  );
}

export default App;
